import React, { useContext } from 'react';
import classNames from 'classnames';
import tracker from '../../service/tracker';
import { SubCategoriesPropTypes } from '../../types';
import { DynamicGigListings, Pagination } from '../common';
import { AppContext } from '../context/listingsContext';
import { MarketplaceLink } from './MarketplaceLink';
import { CategoryBanner } from './CategoryBanner';

import './index.scss';

export const ProSubCategories = (props) => {
    const {
        appFilters,
        pagination,
        displayData
    } = props;

    const { isTouch, listings: [listings] } = useContext(AppContext);

    const {
        proBanner: { header1Text, mediaUrl },
        subCategoryName
    } = displayData;

    const { subCategory: { children = [] } } = appFilters;

    const href = children[0] && children[0].url;

    const onMarketplaceClick = () => {
        tracker.trackGotoMarketPlace();
    };

    const shouldRenderPagination = window && window.location && isTouch;

    return (
        <div className={classNames('pro-categories-page')}>
            <CategoryBanner banner={mediaUrl}
                title={header1Text}
                categoryName={subCategoryName}/>
            <div className="layout-row content-row is-pro-vintage">
                <div className="content">
                    <DynamicGigListings listings={listings}
                        isVintageProTest={true}/>
                </div>
            </div>
            { href && <MarketplaceLink href={href} onClick={onMarketplaceClick}/> }
            { shouldRenderPagination && <Pagination pagination={pagination}/>}
        </div>
    );
};

ProSubCategories.propTypes = SubCategoriesPropTypes;
